<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     开票详情
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="expense-invoice-detail">
    <div class="main-header">
      <div class="title">
        <f-back />
        <span>{{ $route.meta.title }}</span>
      </div>
      <div class="toolbox">&nbsp;</div>
    </div>

    <el-card v-loading="loading" shadow="never" class="mb-md">
      <div class="display-info">
        <el-row>
          <el-col :span="18" class="font-2x">
            <span v-if="oinvoice.invoice_status === 1" class="flex align-items-center">
              <span class="text-warning mr">发票开具中</span>       
              <el-tag v-if="oinvoice.invoice_type == 4" effect="light" type="warning">电子普票</el-tag>
              <el-tag v-else-if="oinvoice.invoice_type == 5" effect="light" type="primary">电子专票</el-tag>
            </span>
            <span v-else class="flex align-items-center">
              <span class="mr">NO. {{ oinvoice.invoice_sn }}</span>
              <el-tag v-if="oinvoice.invoice_type == 4" effect="light" type="warning">电子普票</el-tag>
              <el-tag v-else-if="oinvoice.invoice_type == 5" effect="light" type="primary">电子专票</el-tag>
              <el-button v-if="oinvoice.invoice_type == 4 || oinvoice.invoice_type == 5"
                type="primary"
                plain
                size="small"
                @click="openPdfpreview(oinvoice.attach_url)"
                class="ml"
              >查看电子发票</el-button> 
            </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <span class="text-muted">申请时间：</span>
            <span class="span">{{ oinvoice.applytime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </el-col>
          <el-col v-if="oinvoice.invoicetime" :span="5">
            <span class="text-muted">开票时间：</span>
            <span class="span">{{ oinvoice.invoicetime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </el-col>
        </el-row>
      </div>
      <el-collapse>
        <el-collapse-item name="tax">
          <template slot="title">
            <span class="text-muted">抬头信息：</span>
            <span class="span">{{ oinvoice.corporate_name }}</span>
          </template>
          <div class="display-info">
            <div>
              <span class="text-muted">纳税人识别号：</span>
              <span class="span">{{ oinvoice.corporate_code }}</span>
            </div>
            <div>
              <span class="text-muted">地&nbsp;址、&nbsp;电&nbsp;话：</span>
              <span class="span">{{ oinvoice.detail_address }}</span>
              <span class="span">{{ oinvoice.telephone }}</span>
            </div>
            <div>
              <span class="text-muted">开户行及账号：</span>
              <span class="span">{{ oinvoice.bank_account }}</span>
              <span class="span">{{ oinvoice.bank }}</span>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item v-if="oinvoice.invoice_status > 1 && !(oinvoice.invoice_type == 4 || oinvoice.invoice_type == 5)" name="shipping">
          <template slot="title">
            <span class="text-muted">物流信息：</span>
            <span v-if="oinvoice.shippingid === -1" class="span">无需配送</span>
            <span v-else class="span" :class="oinvoice.shipping_status === 3 ? '' : 'text-warning'">{{ shippingStatusObj[oinvoice.shipping_status] }}</span>
          </template>
          <div v-if="oinvoice.shippingid > 0" class="display-info">
            <el-row>
              <el-col :span="5">
                <span class="text-muted">快递单号：</span>
                <span class="span">{{ shipping.post_com_name }}</span>
                <span class="span">{{ shipping.post_sn }}</span>
              </el-col>
              <el-col :span="5">
                <span class="text-muted">发货时间：</span>
                <span class="span">{{ shipping.createtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
              </el-col>
              <el-col :span="5">
                <span class="text-muted">签收时间：</span>
                <span class="span">{{ shipping.signtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <span class="text-muted">收货信息：</span>
                <span class="span">{{ shipping.to_province }}
                  {{ shipping.to_city }}
                  {{ shipping.to_district }}
                  {{ shipping.to_address }}
                </span>
                <span class="span">{{ shipping.to_contact_man }}</span>
                <span class="span">{{ shipping.to_contact_num }}</span>
              </el-col>
            </el-row>
          </div>
          <div v-else><p>暂无物流信息</p></div>
        </el-collapse-item>
        <div v-if="oinvoice.invoice_type == 4 || oinvoice.invoice_type == 5" style="height:48px;line-height: 48px"> 
          <span class="text-muted">接收邮箱：</span>
          <span class="span">{{ oinvoice.email }}</span>
        </div>
      </el-collapse>
    </el-card>

    <el-card v-loading="loading" shadow="never" class="mb-md">
      <el-table
        ref="listTable"
        class="padding-small"
        :data="orders"
        style="width: 100%">
        <el-table-column type="index" width="50" align="center" />
        <el-table-column label="订单号" min-width="120">
          <template slot-scope="scope">
            <el-link :underline="false" @click="$router.push('/expense/order/detail?orderid=' + scope.row.orderid)">{{ scope.row.order_sn }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="主题" min-width="280" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.subject }}
          </template>
        </el-table-column>
        <el-table-column label="清款时间" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.pay_time | parseTime('{y}/{m}/{d} {h}:{i}') }}
          </template>
        </el-table-column>
        <el-table-column v-if="oinvoice.invoice_status > 1" label="税费" min-width="100" align="right">
          <template slot-scope="scope">
            <span>{{ scope.row.order_tax_total | currency }}</span>
          </template>
        </el-table-column>
        <el-table-column label="付款金额" min-width="100" align="right">
          <template slot-scope="scope">
            <span>{{ scope.row.order_amount_payed | currency }}</span>
          </template>
        </el-table-column>
        <template slot="append">
          <f-table-footer>
            <template slot="right">
              <span v-if="oinvoice.invoice_status > 1" class="text-muted" style="margin-right: 20px;">税额：{{ oinvoice.tax | currency }}</span>
              <span>价税合计：</span>
              <span class="font-2x text-warning">{{ oinvoice.money | currency }}</span>
            </template>
          </f-table-footer>
        </template>
      </el-table>
    </el-card>
    <pdf-preview v-if="activePdf" :show.sync="activePdf" :src="pdfSrc"/>
  </div>
</template>

<script>
import FTableFooter from '@/components/FTableFooter'
import PdfPreview from './components/PdfPreview.vue'
import { getOrderInvoiceDetailApi } from '@/api/expense/expenseOinvoiceApi'
export default {
  name: 'ExpenseOinvoiceDetail',
  components: {
    FTableFooter,
    PdfPreview
  },
  data() {
    return {
      loading: false,
      oinvoiceid: this.$route.query.oinvoiceid,
      oinvoice: {},
      shipping: {},
      orders: [],
      activePdf:false,
      pdfSrc:''
    }
  },
  computed: {
    orderInvoiceStatusObj() {
      return this.$store.getters.orderInvoiceStatusObj
    },
    shippingStatusObj() {
      return this.$store.getters.shippingStatusObj
    }
  },
  watch: {
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      getOrderInvoiceDetailApi(this.oinvoiceid).then(res => {
        this.loading = false
        if (!res.errno) {
          this.oinvoice = Object.assign({}, res.data.oinvoice)
          this.shipping = Object.assign({}, res.data.shipping)
          this.orders = res.data.orders
        } else {
          this.$alert(res.message, {
            type: 'error',
            callback: () => this.$router.go(-1)
          })
        }
      }).catch(err => {
        this.loading = false
        console.log(err)
      })
    },
    openPdfpreview(src){
      this.pdfSrc = src;
      this.activePdf = true;
    },
  }
}
</script>
